import { OnInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityTypeConfig } from '@model/entity-type-config';
import { CommentService } from '@service/comment/comment.service';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { ScrollService } from '@service/scroll.service';
import { StateService } from '@service/state.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { Subscription } from 'rxjs';

@Component({
  template: '',
})
export abstract class EntityDetailComponent implements OnInit, OnDestroy {
  protected abstract entityTypeIdentifier: EntityTypeIdentifier;

  protected entityTypeConfig: EntityTypeConfig = null;

  public doesNotExist: boolean = false;

  public _stateParams: any = {};

  public loading: boolean = false;

  private scrollToCommentsSetEventSubscription: null | Subscription = null;
  private writeCommentSetEventSubscription: null | Subscription = null;
  private writePrivateMessageEventSubscription: null | Subscription = null;

  private extras;

  constructor(
    protected entityTypeConfigService: EntityTypeConfigService,
    public StateService: StateService,
    public Router: Router,
    public ScrollService: ScrollService,
    public CommentService: CommentService,
    public ActivatedRoute: ActivatedRoute,
  ) {
    this.extras = this.Router.getCurrentNavigation().extras.state;
  }

  public ngOnInit() {
    this.entityTypeConfig = this.entityTypeConfigService.getConfigByName(this.entityTypeIdentifier);

    let id = parseInt(this.ActivatedRoute.snapshot.paramMap.get('id'));
    this.getEntity(id);

    if (this.extras) {
      // whenever the commentsComponent in the DOM gets set this will be executed
      this.scrollToCommentsSetEventSubscription = this.ScrollService.writeCommentSet.subscribe(() => {
        // if coming from another state and scrollToComments is set -> scroll there
        if (typeof this.extras['scrollToComments'] != 'undefined' && this.extras['scrollToComments']) {
          setTimeout(() => {
            this.ScrollService.scrollToComments();
          }, 400);
        }
      });

      // whenever the writecomment in the DOM gets set this will be executed
      this.writeCommentSetEventSubscription = this.ScrollService.writeCommentSet.subscribe(() => {
        // if coming from another state and scrollToWriteComment is set -> scroll there
        if (
          this.extras &&
          typeof this.extras['scrollToWriteComment'] != 'undefined' &&
          this.extras['scrollToWriteComment']
        ) {
          setTimeout(() => {
            this.ScrollService.scrollToWriteComment();
          }, 400);
        }
      });

      // whenever the privateMessageComponent in the DOM gets set this will be executed
      this.writePrivateMessageEventSubscription = this.ScrollService.privateMessageComponentSet.subscribe(() => {
        // if coming from another state and scrollToPrivateMessage is set -> scroll there
        if (
          this.extras &&
          typeof this.extras['scrollToPrivateMessage'] != 'undefined' &&
          this.extras['scrollToPrivateMessage']
        ) {
          setTimeout(() => {
            this.ScrollService.scrollToWritePrivateMessage();
          }, 400);
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.scrollToCommentsSetEventSubscription?.unsubscribe();
    this.writeCommentSetEventSubscription?.unsubscribe();
    this.writePrivateMessageEventSubscription?.unsubscribe();
  }

  abstract getEntity(id: number): Promise<void>;
}
